// extracted by mini-css-extract-plugin
export default {"videoWrapper":"style-module--video-wrapper--5f83e"};